module.exports = __webpack_public_path__ + "static/media/animated_ashutosh2.5ff282e0.png";